import { useMsal } from "@azure/msal-react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { loginRequest } from "../authConfig";

export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginPopup({
            ...loginRequest,
            redirectUri: process.env.REACT_APP_POPUP_REDIRECT_URI || "/",
        }).catch(error => {
            console.error("Popup login failed:", error);
        });
    };

    const handleRegister = () => {
        const registerUrl = `https://sdgs.unep.org/user/register?destination=${encodeURIComponent(window.location.href)}`;
        window.open(registerUrl, '_blank');
    };

    return (
        <Stack direction="row" spacing={2}>
            <Button variant="contained" color="primary" onClick={handleLogin}  className="navbar-toggler">
                Login
            </Button>
            <Button variant="contained" color="primary" onClick={handleRegister}>
                Register
            </Button>
        </Stack>
    );
};
